import { Link } from "wouter";
import { cn } from "@/lib/utils";

/** Shared logo treatment — transparent PNG with plum accent; no CSS color filters */
export const LOGO_MARK_IMG_CLASS =
  "w-auto max-w-[220px] h-auto object-contain object-left shrink-0";

const heights = { sm: "h-7", md: "h-9", lg: "h-11" } as const;

interface LogoMarkProps {
  className?: string;
  size?: keyof typeof heights;
}

export function LogoMark({ className, size = "md" }: LogoMarkProps) {
  return (
    <img
      src="/logo.png"
      alt="Godman Capital"
      width={510}
      height={189}
      className={cn(LOGO_MARK_IMG_CLASS, heights[size], className)}
    />
  );
}

/** Sidebar header — logo on a light strip (readable on dark sidebar) */
export function SidebarBrand({ panelLabel }: { panelLabel: string }) {
  return (
    <div className="flex flex-col gap-1.5 sm:gap-2">
      <Link
        href="/"
        className="flex w-full justify-center transition-opacity hover:opacity-90"
      >
        <div className="flex w-full max-w-full justify-center rounded-md bg-background px-2 py-2 sm:px-3 sm:py-2.5">
          <LogoMark size="sm" className="mx-auto max-h-8 w-auto object-contain sm:max-h-9" />
        </div>
      </Link>
      <span className="text-center text-[9px] font-medium uppercase tracking-[0.12em] text-sidebar-primary sm:text-[10px] sm:tracking-[0.15em]">
        {panelLabel}
      </span>
    </div>
  );
}
